/**
 * 中国省市区县数据（用于级联选择）
 * 格式: { "省": { "市": ["区/县"], ... }, ... }
 * 数据来源: area-data（含港澳台）
 */
import pcaa from 'area-data/pcaa';

function buildRegionData(rawPcaa) {
  const provinces = rawPcaa?.['86'] || {};
  const result = {};

  for (const [provinceCode, provinceName] of Object.entries(provinces)) {
    const citiesMap = rawPcaa?.[provinceCode] || {};
    const citiesObj = {};

    for (const [cityCode, cityName] of Object.entries(citiesMap)) {
      const districtsMap = rawPcaa?.[cityCode] || {};
      const districts = Object.entries(districtsMap)
        // 仅保留“区/县”一级（6位行政区划码）；过滤乡镇/街道等更细粒度
        .filter(([code]) => String(code).length === 6)
        .map(([, name]) => name);
      citiesObj[cityName] = districts;
    }

    result[provinceName] = citiesObj;
  }

  return result;
}

export const regionData = buildRegionData(pcaa);

/** 转换为级联选择格式 [{name, children: [{name, children: [...]}]}] */
export function getRegionCascade() {
  return Object.entries(regionData).map(([province, cities]) => ({
    name: province,
    value: province,
    children: Object.entries(cities).map(([city, districts]) => ({
      name: city,
      value: city,
      children: (districts || []).map(d => ({ name: d, value: d }))
    }))
  }));
}

/** 房产用：省+市（有房时选到市） */
export function getHousingProvinceCascade() {
  return Object.entries(regionData).map(([province, cities]) => ({
    name: province,
    value: province,
    children: Object.keys(cities).map(city => ({ name: city, value: city }))
  }));
}
